import React, { useState } from 'react';
import StudentMessages from '../student/StudentMessages';
import StudentNotificationsInbox from '../student/StudentNotificationsInbox';
import './StudentCommunication.css';

/**
 * Student Communication Module Wrapper
 * Integrates: Student Notifications + Student Messages
 */
export default function StudentCommunication({ studentId, studentName }) {
  const [activeTab, setActiveTab] = useState('notifications');

  return (
    <div className="student-comm-wrapper">
      <div className="comm-tabs">
        <button
          className={`comm-tab ${activeTab === 'notifications' ? 'active' : ''}`}
          onClick={() => setActiveTab('notifications')}
        >
          Notifications
        </button>
        <button
          className={`comm-tab ${activeTab === 'messages' ? 'active' : ''}`}
          onClick={() => setActiveTab('messages')}
        >
          Messages with Faculty
        </button>
      </div>

      <div className="comm-content">
        {activeTab === 'notifications' && (
          <StudentNotificationsInbox studentId={studentId} />
        )}
        {activeTab === 'messages' && (
          <StudentMessages studentId={studentId} studentName={studentName} />
        )}
      </div>
    </div>
  );
}
